// extracted by mini-css-extract-plugin
export var copy = "footer-module--copy--e33e8";
export var footer_bottom = "footer-module--footer_bottom--800ac";
export var footer_nav = "footer-module--footer_nav--cbcde";
export var footer_social = "footer-module--footer_social--53065";
export var footer_wrapper = "footer-module--footer_wrapper--273ee";
export var inner_footer_bottom = "footer-module--inner_footer_bottom--1d4a1";